<template>
  <div class="car-item-component container-fluid">
    <div class="row car-item-header">
      <div class="col-xs-6">
      <h4>{{ car.CarType.name }}</h4>
      </div>
      <div class="col-xs-6 text-right">
        <label class="label label-margin" :class="randomLabel">{{ car.CarType.CarClass.name }}</label>
        <label class="label label-success label-margin" v-if="car.Reservations.length === 0">Available</label>
        <label class="label label-danger label-margin" v-if="car.Reservations.length > 0">Unavailable</label>
        <label class="label label-black label-margin" v-if="oneWayTrip"><span class="fa fa-check fa-lg"></span> One Way</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-4 col-xs-12">
        <img class="img-thumbnail" v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( car.CarType.AmazonImage.objectKey ? car.CarType.AmazonImage.objectKey : 'spacer.gif' ) + '?v=' + new Date().getTime()"/>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12">
        <h5><strong>{{ car.name }} (#{{ car.convadisId }} - {{ car.rego }})</strong></h5><br/>
          <div class="small-price-block">
            <p>
              From &nbsp;
              <span class="small-price-block-dollar">$</span>
              <span class="small-price-block-price">{{ cost }}</span>
            </p>
          </div>
          <template v-if="car.Lot.premiumAmount > 0">
            <p><strong>{{ car.Lot.premiumAmount | currency_round }} Premium</strong><br>
              {{ car.Lot.premiumReason }}
            </p>
          </template>
          <template v-if="car.CarFeatures.length > 0">
            <p>
              <strong>Features</strong><br/>
              <template v-for="feature in car.CarFeatures">
                <i v-if="feature.icon" v-bind:class="'fa ' + feature.icon + ' fa-lg'"></i> {{ feature.name }}
              </template>
            </p>
          </template>
        <template v-if="car.Reservations.length > 0">
          <div class="callout callout-danger" v-if="message">{{{ message }}}</div>
          <div class="callout callout-warning" v-if="reloMessage">{{{ reloMessage }}}</div>
        </template>
        <p><span v-if="valid"><button v-on:click="newReservation()" class="btn btn-info btn-sm">Reserve</button></span>
        <a v-link="{ path: '/reserve/car/' + car.uuid + '?s=' + new Date(startTime).getTime() + '&e=' + new Date(endTime).getTime() }" class="btn btn-default btn-sm">View Availability</a></p>
      </div>
      <div class="col-md-5 col-sm-4 col-xs-12">
        <p><strong>Address</strong><br/>{{ car.Lot.address }}<br/>
        <strong>Location Details</strong><br/>{{ car.Lot.addressMemo }}</p><br/>
        <p v-if="location"><i class="fa fa-location-arrow fa-lg"></i> Approx. {{ distance }} away</p>
        <p><a v-bind:href="'https://www.google.com/maps?q='+ car.Lot.latitude +','+ car.Lot.longitude" target="_blank" class="btn btn-default btn-sm">View on Google Maps</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
export default {
  name: 'CarItem',
  props: {
    car: {
      type: Object
    },
    startTime: {
      type: Date
    },
    endTime: {
      type: Date
    },
    lat: {
      type: Number
    },
    long: {
      type: Number
    },
    location: {
      type: Boolean
    }
  },
  data () {
    return {
      cost: 0,
      message: false,
      reloMessage: false,
      futureReservations: false
    }
  },
  computed: {
    oneWayTrip () {
      return this.car.oneWayTrips && this.car.Lot.oneWayTrips && this.car.Organization.oneWayTrips && this.$root.oneWayTrips && !this.car.LotRelocations.length && !this.futureReservations
    },
    randomLabel () {
      if (this.car.CarType.CarClass) {
        let num = this.car.CarType.CarClass.name.charCodeAt(0)
        return {
          'label-warning': num % 5 === 0,
          'label-primary': num % 5 === 1,
          'label-danger': num % 5 === 2,
          'label-default': num % 5 === 3,
          'label-info': num % 5 === 4
        }
      } else {
        return {}
      }
    },
    distance: function () {
      if (this.car.Lot.distance > 1000) {
        return (this.car.Lot.distance / 1000).toFixed(2) + 'km'
      } else {
        return this.car.Lot.distance.toFixed(0) + 'm'
      }
    },
    valid: function () {
      if (this.$parent.$refs.dateTime.valid && this.car.Reservations.length === 0) {
        return true
      } else {
        return false
      }
    }
  },
  ready () {
    this.getCost()
    this.checkConflicts()
  },
  methods: {
    newReservation () {
      this.$parent.reserveModal(this.car)
    },
    checkConflicts () {
      this.message = false
      this.reloMessage = false
      if (this.car.Reservations.length > 0) {
        if (this.car.Reservations[0].OriginalLotUuid) {
          let link = `https://www.google.com/maps/dir/'${this.car.Reservations[0].OriginalLot.latitude},${this.car.Reservations[0].OriginalLot.longitude}'/${this.car.Reservations[0].Lot.latitude},${this.car.Reservations[0].Lot.longitude}/data=!3m1!4b1!4m7!4m6!1m3!2m2!1d145.0580063!2d-37.7004365!1m0!3e2`
          this.reloMessage = `This car is being moved to a new lot during your selected time. It will be available again at <strong>${moment(this.car.Reservations[0].endDate).format('LLLL')}</strong> at <a href="${link}" target="_blank"><u>${this.car.Reservations[0].Lot.address}</u></a>.`
        } else {
          if (moment(this.car.Reservations[0].blockedStartDate).isBetween(moment(this.startTime), moment(this.endTime))) {
            this.message = `The time you have selected is not available for this car. <br/> It is only available until <strong>${moment(this.car.Reservations[0].blockedStartDate).format('LLLL')}</strong> but will
            be available again at <strong>${moment(this.car.Reservations[0].blockedEndDate).format('LLLL')}</strong>`
          } else {
            this.message = `The time you have selected is not available for this car. <br/> It will be available again at <strong>${moment(this.car.Reservations[0].blockedEndDate).format('LLLL')}</strong>`
          }
        }
      }
      if (this.car.LotRelocations.length === 1) {
        let relo = this.car.LotRelocations[0]
        if (!relo.permanent) {
          let end = moment(relo.endDate).add(relo.buffer, 'minutes')
          let endDate = moment(this.endTime)
          if (endDate.isAfter(end)) {
            this.car.LotRelocations = []
          }
        } else {
          let end = moment(relo.endDate).add(relo.buffer, 'minutes')
          let startDate = moment(this.startTime)
          if (startDate.isAfter(end)) {
            this.car.LotRelocations = []
          }
        }
      }
      if (this.car.oneWayTrips && this.car.Lot.oneWayTrips && this.car.Organization.oneWayTrips && this.$root.oneWayTrips) {
        this.getFutureReservations()
      }
    },
    getCost () {
      let authType = this.$route.authType
      let params = {
        carUuid: this.car.uuid,
        startDate: this.startTime,
        endDate: this.endTime,
        extraCredit: 0,
        alreadyPaid: 0
      }
      this.$http.post(`${authType}/update-cost`, params).then((response, status, request) => {
        this.cost = response.data.cost.subTotalCost
      })
    },
    getFutureReservations () {
      let authType = this.$route.authType
      let params = {
        carUuid: this.car.uuid,
        endDate: this.endTime
      }
      this.$http.post(`${authType}/future-reservations`, params).then((response, status, request) => {
        this.futureReservations = parseInt(response.data) > 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CarItem.vue?d58b81e2